import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22HeroSection.tsx%22,%22import%22:%22Montserrat%22,%22arguments%22:[{%22weight%22:%22600%22,%22subsets%22:[%22latin%22]}],%22variableName%22:%22montserrat2%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Montserrat', 'Montserrat Fallback'",
        fontWeight: 600,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
